import { UserRoles } from '@/enums';
import { SimpleEnumType } from '@/types';
import { del_mask } from '@/utils';
import { Getters } from 'vuex-smart-module';
import { Staffs } from '../types';
import StaffState from './state';

export default class StaffGetters extends Getters<StaffState> {
  get filtered_staffs() {
    return this.state.staffs.filter((curr_item: Staffs.Staff) => {
      const filter_city = this.state.filters.city;
      const filter_roles = this.state.filters.role;
      const { search = '' } = this.state.filters;
      let check = false;

      if (!search || !search.trim()) {
        check = true;
      } else {
        const str = search.trim().toLowerCase();
        const name = curr_item?.name?.toLowerCase() || '';
        const surname = curr_item?.surname?.toLowerCase() || '';
        const patronymic = curr_item?.patronymic?.toLowerCase() || '';
        const tel = del_mask(curr_item?.telephone) || '';
        const email = curr_item?.email.toLowerCase() || '';
        const is_valid = [
          name,
          surname,
          patronymic,
          tel,
          email,
        ].some((el) => el.includes(str));

        if (!is_valid) {
          return false;
        }
        check = true;
      }

      if (filter_city === '' || filter_city === null) {
        check = true;
      } else if (curr_item.city === filter_city) {
        check = true;
      } else {
        return false;
      }

      if ((curr_item.is_active_account === this.state.filters.status) || this.state.filters.status === null) {
        check = true;
      } else {
        return false;
      }

      if (filter_roles?.length) {
        const check_roles = curr_item.roles.some(
          (role: SimpleEnumType<UserRoles.Internal>) => this.state.filters.role.some(
            (f_role) => role.slug === f_role,
          ),
        );

        if (check_roles) {
          check = true;
        } else {
          return false;
        }
      } else if (!filter_roles.length) {
        check = true;
      } else {
        return false;
      }
      return check;
    });
  }
}
